import styled from 'styled-components'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

export const Alert = styled.div`
  background-color: ${({ theme }) => theme['-ds-information-100'].value};
  padding: 30px;

  display: flex;
  flex-direction: column;
  border-radius: 8px;

  ${media.md`
    flex-direction: row;
    align-items: center;
    padding: 60px;
  `}
`

export const LogoWrapper = styled.div`
  flex-shrink: 0;
  align-self: baseline;
  margin: 0 0 24px 0;

  svg {
    width: 64px;
    height: 64px;
    color: ${({ theme }) => theme?.['-ds-core-300']?.value};
  }

  ${media.md`
    margin: 0 24px 0 0;
  `}
`

export const ContentWrapper = styled.div`
  padding-right: 20px;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-weight: 400;
  margin: 0 0 24px 0;

  ${media.md`
    max-width: 70%;
    margin: 0;
  `}
`

export const Heading = styled.h4`
  ${typeStyle('-ds-font-title-3')}
`

export const Paragraph = styled.p`
  ${typeStyle('-ds-font-lead-sm-light')}

  a {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    text-decoration: underline;
  }
`

export const ButtonWrapper = styled.div`
  ${media.md`
    margin-left: auto;
  `}
`
